import request from '@/utils/request'

export function uploadDetectDocx(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/detect/upload/docx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function deleteDetectUpload(uploadId) {
  return request.delete(`/detect/upload/${uploadId}`)
}

export function submitDetect(data) {
  return request.post('/detect/submit', data)
}

export function getDetectTaskDetail(taskNo) {
  return request.get(`/detect/task/${taskNo}/detail`)
}

export function getDetectTasks(params) {
  return request.get('/detect/tasks', { params })
}

export function deleteDetectRecord(taskNo) {
  return request.delete(`/detect/tasks/${taskNo}`)
}

export function downloadDetectReport(taskNo) {
  return request.get(`/detect/task/${taskNo}/report/download`, {
    responseType: 'blob',
    timeout: 120000
  })
}
